import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { onMounted } from "vue";
import { useContactStore } from "@/store/contact"; //引入news仓库

export default {
  name: "App",
  components: {
    Header: Header,
    Footer: Footer
  },
  setup: function setup() {
    var store = useContactStore();
    onMounted(function () {
      var token = localStorage.getItem('token');

      if (!token) {// store.getToken() //获取token
      }
    });
  }
};